module.exports = __webpack_public_path__ + "static/media/right.1653eefc.png";